<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'PointDisplay',
})
</script>
<template>
  <Collapse v-if="result?.positions?.length" v-model:activeKey="activeKey">
    <Item v-for="(item, index) in result.positions" :key="item.id" :record="item" :index="index" />
  </Collapse>
  <Empty v-else />
</template>

<script lang="ts" setup name="PointDisplay">
import { ref } from 'vue'
import { Collapse } from 'ant-design-vue'
import { Empty } from '-/Common/Empty'
import { useDetailLy } from '@/hooks/useDetailLy'
import Item from './Item.vue'
const { result } = useDetailLy()
const activeKey = ref(result.value?.positions?.length ? result.value?.positions?.map(item => item.id) : [])
</script>
